export const ABSMARTLY_ID = 'absmartly_id';
export const IN_MOBILE_APP = 'in_mobile_app';
export const LOGGED_IN = 'logged_in';
export const OAUTH_TOKEN = 'oauth_token';
export const USER_ID = 'user_id';
export const USER_ROLES = 'user_roles';
// Cookies
export const ENABLED_MARKETING_COOKIES = 'enable_marketing_cookies';
export const ENABLED_ANALYTICAL_COOKIES = 'enable_analytical_cookies';
export const COOKIE_PREFERENCES_USED_CTA = 'cookie_preferences_used_cta';
export const HAS_PENDING_COOKIE_CONSENT_SYNC = 'has_pending_cookie_consent_sync';
export const DONT_SHOW_COOKIE_BAR_AGAIN = 'dont_show_cookie_bar_again';
